module.exports = __webpack_public_path__ + "img/echoing_logo_white_nobg.b07df532.png";